import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { Grid } from './../../../assets/theme/layout';
import { Page, Wrapper, Paper, Content, Button, Toolbar, ButtonsGroup } from './../../../components/ui';
import { InputTextField, SelectField, OptionField, InputDateField } from './../../../components/ui/input';
import { LeadService, StoreService, CountryService, StateService, OfferService } from './../../../services';
import { findPermissionProps, isEmail } from './../../../utilities/utils';

import API from './../../../config/api';
import TEXT from './../../../config/text';

function getDefaultStoreFromUser(user) {
  if (!user) {
    return 'none';
  }

  if (user.store) {
    return user.store;
  }

  if (Array.isArray(user.stores) && user.stores.length > 0) {
    return user.stores[0];
  }

  return 'none';
}

const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = TEXT.validation.required;
  }

  if (!values.surname) {
    errors.surname = TEXT.validation.required;
  }

  if (!values.phone) {
    errors.phone = TEXT.validation.required;
  }

  if (values.email && isEmail(values.email)) {
    errors.email = TEXT.validation.email_invalid;
  }

  return errors;
};

class Page__LeadForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      permission: null,
      name: '...',
      title: '...',
      submited: false,
      stores: [],
      campaigns: [],
      countries: [],
      states: []
    };
  }

  componentDidMount(){
    this._Init();
  }

  componentDidUpdate(prevProps){
    if(this.props.country !== prevProps.country){
      this._LoadStates(this.props.country);
    }
  }

  _Init = () => {
    const defaultStore = getDefaultStoreFromUser(this.props.session.user);

    this.setState({
      permission: findPermissionProps(this.props.session, API.permissions.leads, this.props.t('text.leads')),
      title: this.props.t('text.registry_new')
    });

    this.props.dispatch(change('Page__LeadForm', 'store', defaultStore));

    Promise.all([
      StoreService.list(0, { items: 1000 }),
      CountryService.list(),
      OfferService.list(0, { items: 1000, enabled: true })
    ]).then(([storesResponse, countriesResponse, offersResponse]) => {
      const campaigns = [
        { value: 'whatsapp', label: 'WhatsApp' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'x', label: 'X' },
        { value: 'facebook', label: 'Facebook' }
      ];
      const sourceMap = new Set(['whatsapp', 'instagram', 'x', 'facebook']);

      (offersResponse.offers || []).forEach((offer) => {
        const shouldInclude = Boolean(offer.manual) || (Boolean(offer.enabled) && Boolean(offer.published));
        const source = offer.source ? offer.source.trim() : '';

        if(shouldInclude && source && !sourceMap.has(source)){
          sourceMap.add(source);
          campaigns.push({ value: source, label: source });
        }
      });

      this.setState({
        stores: storesResponse.stores || [],
        campaigns: campaigns,
        countries: countriesResponse.countries || []
      });
    }).catch(() => {
      this.props.alertShow({
        open: true,
        severity: 'error',
        message: TEXT.message.error
      });
    });
  }

  _LoadStates = (countryId) => {
    if(!countryId || countryId === 'none'){
      this.setState({ states: [] });
      this.props.dispatch(change('Page__LeadForm', 'state', 'none'));
      return;
    }

    StateService.findByCountryId(countryId).then((response) => {
      this.setState({ states: response.states || [] });
    }).catch(() => {
      this.setState({ states: [] });
    });
  }

  handleSubmitForm = (values) => {
    this.setState({ submited: true });

    const payload = { ...values };
    if (payload.rating === 'none') {
      delete payload.rating;
    }

    LeadService.save(payload).then(() => {
      this.props.alertShow({
        open: true,
        severity: 'success',
        message: 'El lead fue guardado.'
      });

      this.props.history.push('/leads');
    }).catch((error) => {
      this.setState({ submited: false });
      this.props.alertShow({
        open: true,
        severity: 'error',
        message: error.data && error.data.message ? error.data.message : TEXT.message.error
      });
    });
  }

  render(){
    const { handleSubmit, invalid, t } = this.props;
    const { permission, name, title, submited, stores, campaigns, countries, states } = this.state;

    return(
      <Page>
        <Wrapper>
          <Toolbar title={permission ? permission.name : name} dividerMobile>
            <Button component={ NavLink } to="/leads" icon="back" size="medium">
              {t('button.back')}
            </Button>
          </Toolbar>

          <Paper disablePadding>
            <Toolbar title={ title } size="medium" variant="divider" disableMargin />

            <form onSubmit={ handleSubmit(this.handleSubmitForm) }>
              <Content divider>
                <Toolbar title={t('text.campaign')} size="small" disableMargin />
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Field name="source" component={ SelectField } label={t('field.source')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      { campaigns.map((campaign) => <OptionField key={ campaign.value } value={ campaign.value }>{campaign.label}</OptionField>) }
                    </Field>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}><Field name="code" component={ InputTextField } label={t('field.code')} /></Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Field name="store" component={ SelectField } label={t('text.stores')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      { stores.map((store) => <OptionField key={ store._id } value={ store._id }>{store.name}</OptionField>) }
                    </Field>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Field name="rating" component={ SelectField } label={t('field.rating')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      <OptionField value="Error">{t('field.option_field.error')}</OptionField>
                      <OptionField value="Malo">{t('field.option_field.malo')}</OptionField>
                      <OptionField value="Regular">{t('field.option_field.regular')}</OptionField>
                      <OptionField value="Bueno">{t('field.option_field.bueno')}</OptionField>
                      <OptionField value="Muy bueno">{t('field.option_field.muy_bueno')}</OptionField>
                    </Field>
                  </Grid>
                </Grid>
              </Content>

              <Content divider>
                <Toolbar title={t('text.personal')} size="small" disableMargin />
                <Grid container spacing={3}>
                  <Grid item xl={3} lg={3} md={6} sm={12} xs={12}><Field name="name" component={ InputTextField } label={t('field.name')} required /></Grid>
                  <Grid item xl={3} lg={3} md={6} sm={12} xs={12}><Field name="surname" component={ InputTextField } label={t('field.surname')} required /></Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}><Field name="identifire" component={ InputTextField } label={t('field.document_number')} /></Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
                    <Field name="genre" component={ SelectField } label={t('field.gender')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      <OptionField value="male">Masculino</OptionField>
                      <OptionField value="famale">Femenino</OptionField>
                    </Field>
                  </Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}><Field name="birthdate" component={ InputDateField } label={t('field.birthdate')} /></Grid>
                </Grid>
              </Content>

              <Content divider>
                <Toolbar title={t('text.contact')} size="small" disableMargin />
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}><Field name="email" component={ InputTextField } label={t('field.email')} /></Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}><Field name="phone" component={ InputTextField } label={t('field.phone')} required /></Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}><Field name="mobile_phone" component={ InputTextField } label={t('field.mobile_phone')} /></Grid>
                </Grid>
              </Content>

              <Content divider>
                <Toolbar title={t('text.location')} size="small" disableMargin />
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}><Field name="address_street" component={ InputTextField } label={t('field.address')} /></Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}><Field name="zip" component={ InputTextField } label={t('field.postal_code')} /></Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}><Field name="city" component={ InputTextField } label={t('field.locality')} /></Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
                    <Field name="country" component={ SelectField } label={t('field.country')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      { countries.map((country) => <OptionField key={ country._id } value={ country._id }>{country.name}</OptionField>) }
                    </Field>
                  </Grid>
                  <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
                    <Field name="state" component={ SelectField } label={t('field.state')}>
                      <OptionField value="none">{t('field.option_field.none')}</OptionField>
                      { states.map((state) => <OptionField key={ state._id } value={ state._id }>{state.name}</OptionField>) }
                    </Field>
                  </Grid>
                </Grid>
              </Content>

              <Content>
                <Toolbar title={t('field.observation')} size="small" disableMargin />
                <Grid container spacing={3}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Field name="notes" component={ InputTextField } label={t('field.observation')} multiline rows={5} />
                  </Grid>
                </Grid>
              </Content>

              <Content>
                <ButtonsGroup align="right">
                  <Button component={ NavLink } to="/leads" color="danger" size="medium" icon="cancel">{t('button.cancel')}</Button>
                  <Button type="submit" size="medium" icon="add" color="success" disabled={ invalid || submited }>{t('button.save')}</Button>
                </ButtonsGroup>
              </Content>
            </form>
          </Paper>
        </Wrapper>
      </Page>
    )
  }
}

Page__LeadForm = reduxForm({
  form: 'Page__LeadForm',
  validate,
  initialValues: {
    source: 'whatsapp',
    code: '',
    store: 'none',
    rating: 'none',
    genre: 'none',
    country: 'none',
    state: 'none'
  }
})(Page__LeadForm);

const selector = formValueSelector('Page__LeadForm');

Page__LeadForm = connect(state => ({
  country: selector(state, 'country')
}))(Page__LeadForm);

const mapStateToProps = (state) => ({ session: state.userState });

const mapDispatchToProps = (dispatch) => ({
  alertShow: (data) => dispatch({ type: 'ALERT_SHOW', data: data })
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__LeadForm));
